/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppointmentResponseDto,
  CreateAppointmentRequestDto,
  ErrorResponse,
  UpdateAppointmentRequestDto,
} from '../models/index';
import {
    AppointmentResponseDtoFromJSON,
    AppointmentResponseDtoToJSON,
    CreateAppointmentRequestDtoFromJSON,
    CreateAppointmentRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UpdateAppointmentRequestDtoFromJSON,
    UpdateAppointmentRequestDtoToJSON,
} from '../models/index';

export interface CreateAppointmentRequest {
    createAppointmentRequestDto: CreateAppointmentRequestDto;
}

export interface DeleteAppointmentRequest {
    id: string;
}

export interface GetAppointmentByIdRequest {
    id: string;
}

export interface GetAppointmentsByProviderRequest {
    startDate?: Date;
    endDate?: Date;
    orderBy?: string;
}

export interface UpdateAppointmentRequest {
    id: string;
    updateAppointmentRequestDto: UpdateAppointmentRequestDto;
}

/**
 * 
 */
export class ProviderAppointmentsApi extends runtime.BaseAPI {

    /**
     * Creates a new appointment for a patient with a provider
     * Create a new appointment
     */
    async createAppointmentRaw(requestParameters: CreateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponseDto>> {
        if (requestParameters['createAppointmentRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAppointmentRequestDto',
                'Required parameter "createAppointmentRequestDto" was null or undefined when calling createAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAppointmentRequestDtoToJSON(requestParameters['createAppointmentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new appointment for a patient with a provider
     * Create a new appointment
     */
    async createAppointment(requestParameters: CreateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponseDto> {
        const response = await this.createAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an appointment
     * Delete appointment
     */
    async deleteAppointmentRaw(requestParameters: DeleteAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an appointment
     * Delete appointment
     */
    async deleteAppointment(requestParameters: DeleteAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAppointmentRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a specific appointment by its ID
     * Get appointment by ID
     */
    async getAppointmentByIdRaw(requestParameters: GetAppointmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAppointmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retrieves a specific appointment by its ID
     * Get appointment by ID
     */
    async getAppointmentById(requestParameters: GetAppointmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAppointmentByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all appointments for a specific provider
     * Get appointments by provider
     */
    async getAppointmentsByProviderRaw(requestParameters: GetAppointmentsByProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseDtoFromJSON));
    }

    /**
     * Retrieves all appointments for a specific provider
     * Get appointments by provider
     */
    async getAppointmentsByProvider(requestParameters: GetAppointmentsByProviderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponseDto>> {
        const response = await this.getAppointmentsByProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing appointment
     * Update appointment
     */
    async updateAppointmentRaw(requestParameters: UpdateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAppointment().'
            );
        }

        if (requestParameters['updateAppointmentRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateAppointmentRequestDto',
                'Required parameter "updateAppointmentRequestDto" was null or undefined when calling updateAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/appointments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAppointmentRequestDtoToJSON(requestParameters['updateAppointmentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Updates an existing appointment
     * Update appointment
     */
    async updateAppointment(requestParameters: UpdateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponseDto> {
        const response = await this.updateAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
